import API_ROUTES from "~/api-routes";
import apiService from "~/services/service";
import { z } from "zod";

const SAS_TOKEN = "SAS_TOKEN";
const SAS_TOKEN_EXPIRES_ON = "SAS_TOKEN_EXPIRES_ON";
const containerName = "document-repo";

export const getFileIcon = (file) => {
  if (file?.type?.includes?.("pdf")) return "pi pi-file-pdf";
  else if (file?.type?.includes?.("msword") || file?.type?.includes?.("word"))
    return "pi pi-file-word";
  else if (
    file?.type?.includes?.("png") ||
    file?.type?.includes?.("jpg") ||
    file?.type?.includes?.("jpeg")
  )
    return "pi pi-image";
  else if (
    file?.type?.includes?.("csv") ||
    file?.type?.includes?.("excel") ||
    file?.type?.includes?.("spreadsheet")
  )
    return "pi pi-file-excel";
  else return "pi pi-file";
};

export const downloadFileHandler = async (
  file,
  containerName = "document-repo",
) => {
  try {
    const blobUrl = file.blob_url.split("?")[0];
    const downloadUrl = await fetchBlobUrl(blobUrl, containerName);
    const response = await fetch(downloadUrl);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = file.name;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Error downloading the file:", error);
  }
};
export const getDocumentLabel = (filename) => {
  const extension = filename.split(".").pop().toLowerCase();
  const extensionMap = {
    jpg: "Image Document",
    jpeg: "Image Document",
    png: "Image Document",
    pdf: "PDF Document",
    doc: "Word Document",
    docx: "Word Document",
    xls: "Excel Document",
    xlsx: "Excel Document",
    ppt: "PPT Document",
    pptx: "PPT Document",
    txt: "Text Document",
    csv: "CSV Document",
  };
  return extensionMap[extension] || "Other Document";
};

export const formatFileSize = (bytes) => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "kb", "mb", "gb", "tb"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

export const getSasToken = async (containerName) => {
  const sasToken = sessionStorage.getItem(SAS_TOKEN);
  const expiresOn = sessionStorage.getItem(SAS_TOKEN_EXPIRES_ON);
  const isTokenValid = () => {
    if (!sasToken || !expiresOn) return false;

    const now = new Date();
    const expiry = new Date(expiresOn);
    // one minute buffer
    const bufferMs = 60 * 1000;

    return now.getTime() + bufferMs < expiry.getTime();
  };
  if (isTokenValid()) {
    return sasToken;
  }
  // fetch new token if token is not found or expired
  const newTemporaryToken = await fetchTemporarySasToken(containerName);
  sessionStorage.setItem(SAS_TOKEN, newTemporaryToken.sasToken);
  sessionStorage.setItem(SAS_TOKEN_EXPIRES_ON, newTemporaryToken.expiresOn);
  return newTemporaryToken.sasToken;
};

const fetchTemporarySasToken = async (containerName) => {
  try {
    const data = await apiService(API_ROUTES.FETCH_TEMPORARAY_TOKEN, "GET", {
      replace: { container: containerName },
    });
    return data?.data;
  } catch (err) {
    console.log(`An unexpected error occured while fetching the token: ${err}`);
  }
};

export const openFileInNewTab = async ({ objectURL }) => {
  try {
    const response = await fetch(objectURL);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (err) {
    console.error("Error opening preview:", err);
  }
};

export const openPreviewInNewTab = async (file) => {
  try {
    const blobUrl = file.objectURL.split("?")[0];
    const downloadUrl = await fetchBlobUrl(blobUrl, containerName);
    const response = await fetch(downloadUrl);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 5000);
  } catch (error) {
    console.error("Error opening preview:", error);
  }
};

export const removeToken = () => {
  sessionStorage.removeItem("SAS_TOKEN");
  sessionStorage.removeItem("SAS_TOKEN_EXPIRES_ON");
};

const fetchBlobUrl = async (blobUrl, containerName) => {
  try {
    const data = await apiService(API_ROUTES.FETCH_BLOB_URL, "GET", {
      replace: { blobUrl, containerName },
      schema: z.object({
        blobUrl: z.string(),
        containerName: z.string(),
      }),
    });
    return data?.data?.baseUrl;
  } catch (err) {
    console.log(
      "An unexpected error occurred whiled fetching blob url ",
      err.message,
    );
    throw err;
  }
};

export const getFilenameFromReference = (fileReference) => {
  if (!fileReference) return "";
  try {
    const url = new URL(fileReference);
    const pathname = url.pathname;
    const filename = pathname.substring(pathname.lastIndexOf("/") + 1);
    return decodeURIComponent(filename);
  } catch (error) {
    console.error("Error extracting filename from reference:", error);
    return "";
  }
};
export const PayslipStatusMap = {
  pending: "Processing",
  rejected: "Rejected",
  approved: "Approved",
  released: "Released",
  matched: "Awaiting Review",
  unmatched: "Awaiting Review",
  no_match: "Awaiting Review",
  extraction_failed: "Awaiting Review",
};
